module.exports = __webpack_public_path__ + "97de291f7980e264dfc7d1398c5fd606.png";